import React from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'
import styles from 'modules/Finance/Wallets/subcomponents/StatusLabel/StatusLabel.module.scss'

const StatusLabel = ({ type = 'default', className = '', children = null }) => (
  <div
    className={clsx(
      styles['status-label'],
      styles['status-label__' + type],
      className,
    )}
  >
    {children}
  </div>
)

export default StatusLabel

StatusLabel.propTypes = {
  type: PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.oneOf([null]),
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
}
